import {
    Grid, Typography, Box, 
} from "@mui/material";
import { useState, useEffect } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import * as CONSTANTS from "../../constants"

import { submit_new_wazaren_request } from "../../services/topic_request";

const getConfirmationFormByStatusCode = (success, lang) => {

    const iconStyle = {
        transition: 'transform 0.5s, opacity 0.5s',
        display: 'inline-block',
    };

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                padding: 2,
            }}
        >
            {success === null && (
                <CircularProgress size={40} color="primary" style={iconStyle} />
            )}
            {success === true && (
                <CheckCircleIcon
                style={{
                    ...iconStyle,
                    transform: 'scale(1.2)',
                }}
                color="success"
                />
            )}
            {success === false && (
                <CancelIcon
                    style={{
                        ...iconStyle,
                        transform: 'scale(1.2)',
                    }}
                    color="error"
                />
            )}
            <Typography variant="h6" sx={{ marginTop: 1 }}>
                {success === null
                ? CONSTANTS.REQUEST_TOPIC.CONFIRMATION_MESSAGE.UPLOADING[lang]
                : success === true
                ? CONSTANTS.REQUEST_TOPIC.CONFIRMATION_MESSAGE.UPLOAD_SUCCESSFUL[lang]
                : success === false
                ? CONSTANTS.REQUEST_TOPIC.CONFIRMATION_MESSAGE.UPLOAD_FAILED[lang]
                : ''}
            </Typography>
        </Box>
    );
}


const ConfirmationForm = ({formik, lang}) => {

    useEffect(() => { window.scrollTo(0, 0) }, []);

    const [msg, setMsg] = useState('');
    const [success, setSuccess] = useState(null);
    const [statusCode, setStatusCode] = useState(0);
    const [sent, setSent] = useState(false);
    
    // send an request to server to submit and render sending request.
    const submitData = async (data) => {
        const [status, result] = await submit_new_wazaren_request(data);
        setStatusCode(status);
        setMsg(result.msg);
        setSuccess(result.success);
    };

    const data = {
        requester: '',
        requester_remarks: '',
        name: {
            en: formik.values.name_en,
            jp: formik.values.name_jp,
            tc: formik.values.name_tc,
            sc: formik.values.name_sc,
        },
        default_name: formik.values.default_name,
        tags: formik.values.tags,
        description: {
            en: formik.values.description_en,
            jp: formik.values.description_jp,
            tc: formik.values.description_tc,
            sc: formik.values.description_sc,
        },
        creator_uid: formik.values.creator_uid,
        editor_uid: formik.values.editor_uid,
        date_created: {
            value: formik.values.date_created? formik.values.date_created.toISOString(): '',
            has_year: formik.values.has_year,
            has_month: formik.values.has_month,
            has_day: formik.values.has_day,
        },
        date_last_updated: new Date(),
        video_source: {
            youtube: formik.values.video_youtube,
            bilibili: formik.values.video_bilibili,
            x: formik.values.video_x
        },
        video_remark: {
            youtube: formik.values.remark_youtube,
            bilibili: formik.values.remark_bilibili,
            x: formik.values.remark_x
        },
    }
    if (!sent) {
        setSent(true);
        submitData(data);
    }

    return (
        <Grid
            container
            spacing={2}
        >
            {getConfirmationFormByStatusCode(success, lang)}
        </Grid>
    )
}

export default ConfirmationForm;